const httpLib = require('./http-library.js');
const publicConfig = require('../public-config.js');
const ssoHost = publicConfig.external_address;

exports.Nux = {
  read: function readNux (query, accessToken, callback) {
    const uxQuery = query ? '?' + query : '';
    const requestParams = {
      host: ssoHost,
      path: '/v1/profiles/me/experience' + uxQuery,
      method: 'GET',
      headers: {
        Authorization: 'Bearer ' + accessToken
      }
    };
    httpLib.request(requestParams, function (response) {
      callback(response);
    }, null);
  }
};
